<template>
  <div v-if="agreement">
    <div class="page-title underline mb-4"><mdb-icon  icon="check-double" /> {{agreement.title}}</div>
    <div v-html="agreement.content"/>
    <div class="text-center">
      <mdb-btn icon="list" class="py-2" @click="$router.back()">목록</mdb-btn>
      <mdb-btn icon="edit" class="py-2" color="primary" @click="onEdit(_id)">수정</mdb-btn>
      <mdb-btn icon="times" class="py-2" color="danger" @click="onDelete(_id)">삭제</mdb-btn>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'StaffAgreement',
  components: {},
  props: [],
  data: () => ({
    TAG: 'StaffAgreement :',
    agreement: undefined
  }),
  computed: {
    _id () { return this.$route.params._id }
  },
  methods: {
    onEdit (_id) {
      this.$router.push({
        name: 'StaffAgreementEdit',
        params: { _id }
      })
    },
    async onDelete (_id) {
      if (!confirm('삭제할까요?')) return
      await this.agreement.delete()
      this.$router.back()
    }
  },
  async created () {
    this.agreement = await this.$Agreement.get(this._id)
  }
}
</script>
